import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Create async thunk to fetch job details by jobId
export const fetchJobDetails = createAsyncThunk(
  'jobDetails/fetchJobDetails',
  async (jobId, { rejectWithValue }) => {
    try {
      const ticketToken = sessionStorage.getItem('ticketToken');
      // console.log('Token:', ticketToken); // Verify the token is being retrieved correctly

      // Make the API call with headers and request body
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/provider/get-job-details`, 
        { jobId: jobId }, // Send jobId in the request body
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`,
          },
        }
      );
  // Check and log if each applicant is hired
  // const appliedCandidates = response.data.data.appliedCandidates.map((candidate) => {
  //   const isHired = candidate.isHired;
  //   console.log(`Applicant ${candidate.userId} - ${candidate.FullName} is ${isHired ? 'Hired' : 'Not Hired'}`);
  //   return {
  //     userId: candidate.userId,
  //     FullName: candidate.FullName,
  //     profile_image_url: candidate.profile_image_url,
  //     isHired, // Map the isHired flag
  //   };
  // });
      // Return the mapped job details
      return {
        jobTitle: response.data.data.jobTitle || 'No title available',
        description: response.data.data.description || 'No description available',
        // appliedCandidates: response.data.data.appliedCandidates || [], 
        appliedCandidates: response.data.data.appliedCandidates.map((candidate) => {
        //   userId: candidate.userId,
        //   FullName: candidate.FullName,
        //   profile_image_url: candidate.profile_image_url,
        //   isHired: candidate.isHired, // Map the isHired flag
        // })),
        const isHired = candidate.isHired;
        // console.log(`Applicant ${candidate.userId} - ${candidate.FullName} is ${isHired ? 'Hired' : 'Not Hired'}`);
        return {
          userId: candidate.userId,
          FullName: candidate.FullName,
          profile_image_url: candidate.profile_image_url,
          isHired, // Map the isHired flag
        };
      }),
      hiredCandidates: (response.data.data.hiredCandidates || []).map((candidate) => {
        const isHired = candidate.isHired;
        return {
          userId: candidate.userId,
          FullName: candidate.FullName || 'No Name',
          profile_image_url: candidate.profile_image_url || 'default_profile_image_url', // Use a default image if missing
          isHired: true,
        };
      }),
        startDate: response.data.data.formattedJobStartDate || 'N/A',
        endDate: response.data.data.formattedJobEndDate || 'N/A',
        startTime: response.data.data.startTime || 'N/A',
        endTime: response.data.data.endTime || 'N/A',
        salary: response.data.data.salary || 0,
        salaryUnit: response.data.data.salaryUnit || 'N/A',
        currencyType: response.data.data.currencyType || 'N/A',
        mandatorySkills: response.data.data.mandatorySkills || 'No mandatory skills specified',
        otherSkills: response.data.data.skills || 'No skills specified',
        vacancies: response.data.data.vacancies || 0,
        settlementPeriod: response.data.data.settlementPeriod || 0,
        country: response.data.data.country || 'No country specified',
        address: response.data.data.address || 'No address specified',
        pinCode: response.data.data.pincode?.postalCode || 'No postal code specified',
        region: response.data.data.pincode?.region || 'No region specified',
      };
    } catch (error) {
      console.error('Error fetching job details:', error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Add new async thunk for invoice payment details
export const fetchInvoicePaymentDetails = createAsyncThunk(
  'jobDetails/fetchInvoicePaymentDetails',
  async (jobId, { rejectWithValue }) => {
    try {
      const ticketToken = sessionStorage.getItem('ticketToken');
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/provider/get-invoice-payment-details`,
        { jobId },
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Create a slice for job details
const jobDetailsSlice = createSlice({
  name: 'jobDetails',
  initialState: {
    jobDetails: {},
    invoicePaymentDetails: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.jobDetails = action.payload;
      })
      .addCase(fetchJobDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // New cases for invoice payment details
      .addCase(fetchInvoicePaymentDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoicePaymentDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.invoicePaymentDetails = action.payload;
      })
      .addCase(fetchInvoicePaymentDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default jobDetailsSlice.reducer;
